/**
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getFormDetail(keyId) {
    return request(api.operate.MASS_SEND_CIRCLE + '/' + keyId, METHOD.GET);
  },
  async saveFormDetail(result) {
    return request(api.operate.MASS_SEND_CIRCLE, METHOD.POST, result);
  },

  /**
   * 获取发表情况
   */
  async checkResult(keyId) {
    return request(api.operate.MASS_SEND_WORK + '/wxMomentsTaskLog?taskId=' + keyId, METHOD.GET);
  },
  /**
   * 同步任务数据
   */
  async synchronization(keyId) {
    return request(api.operate.MASS_SEND_CIRCLE + '/getMomentsTaskResult?taskId=' + keyId, METHOD.GET);
  },

  /**
   * 临时的获取用户数据
   * @param result
   * @return {Promise<AxiosResponse<T>>}
   */
  async getUserCustomer(result) {
    return request(api.modulePaths.BUSSINESS + '/customer/wechatMoments/getFollowUserList', METHOD.GET, result);
  },
  /**
   * 获取标签下拉
   * @param result
   * @return {Promise<AxiosResponse<T>>}
   */
  async getTagList(result) {
    return request(api.client.CUSTTAG + '/queryWxTagName', METHOD.GET, result);
  },
}

export default {dataApi}